import { ShieldCheck, UserCheck, HeartPulse, Stethoscope } from "lucide-react";
import useReveal from "../hooks/useReveal";

const benefits = [
    { icon: ShieldCheck, label: "Atención especializada" },
    { icon: UserCheck, label: "Seguimiento personalizado" },
    { icon: HeartPulse, label: "Enfoque integral en tu salud" },
    { icon: Stethoscope, label: "Respaldo de tu póliza Sofía" },
];

const sedes = [
    "Hospital San Ángel Inn Satélite · Piso 13 · Consultorio 1326",
    "Hospital Star Médica Lomas Verdes · Piso 9 · Consultorio 914",
];

const Aseguradoras = () => {
    const ref = useReveal();
    const ref2 = useReveal();

    return (
        <section
            id="aseguradoras"
            data-testid="aseguradoras-section"
            className="relative py-24 lg:py-28 bg-cream overflow-hidden"
        >
            <div className="absolute -top-32 -left-32 w-[480px] h-[480px] rounded-full bg-gold/[0.05] blur-3xl pointer-events-none" />

            <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
                <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
                    {/* Copy */}
                    <div ref={ref} className="reveal lg:col-span-7">
                        <div className="flex items-center gap-4 mb-6">
                            <span className="block w-16 h-px bg-gold" />
                            <span className="eyebrow">Aseguradoras · Red médica</span>
                        </div>

                        <h2
                            data-testid="aseguradoras-heading"
                            className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-navy"
                        >
                            Ya formo parte de la{" "}
                            <span className="italic text-navy/85">red médica de Sofía.</span>
                        </h2>

                        <p className="mt-8 text-ink/75 text-[15px] sm:text-base leading-relaxed font-light max-w-2xl">
                            Si eres asegurado de{" "}
                            <span className="font-medium text-navy">Sofía</span>, ya puedes
                            agendar tu consulta conmigo y recibir{" "}
                            <span className="font-medium text-navy">atención especializada</span>{" "}
                            con el respaldo de tu póliza, sin trámites adicionales.
                        </p>

                        <ul className="mt-10 grid sm:grid-cols-2 gap-3">
                            {benefits.map(({ icon: Icon, label }, i) => (
                                <li
                                    key={label}
                                    data-testid={`aseguradoras-benefit-${i}`}
                                    className="flex items-center gap-3 px-4 py-3 border border-navy/10 bg-white/70 hover:border-gold/50 transition-colors"
                                >
                                    <span className="w-9 h-9 border border-gold/50 flex items-center justify-center text-gold shrink-0">
                                        <Icon size={16} strokeWidth={1.5} />
                                    </span>
                                    <span className="text-[12.5px] tracking-[0.16em] uppercase font-medium text-navy">
                                        {label}
                                    </span>
                                </li>
                            ))}
                        </ul>

                        <p className="mt-8 text-[12px] tracking-[0.22em] uppercase text-ink/55">
                            Sedes habilitadas para pacientes Sofía:
                        </p>
                        <ul className="mt-3 space-y-2">
                            {sedes.map((s) => (
                                <li
                                    key={s}
                                    className="flex items-start gap-3 text-[13.5px] text-navy/85 font-light"
                                >
                                    <span className="mt-2 w-1 h-1 rounded-full bg-gold shrink-0" />
                                    <span>{s}</span>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Sofía badge card */}
                    <div ref={ref2} className="reveal lg:col-span-5">
                        <div className="relative bg-navy text-cream border-t-2 border-gold p-10 lg:p-12 text-center">
                            <div className="absolute top-2 left-0 right-0 h-px bg-gold/20" />

                            <span className="eyebrow !text-gold">Cobertura activa</span>

                            <p className="mt-6 font-display text-cream/70 text-lg italic">
                                Red médica
                            </p>
                            <p
                                className="font-display text-6xl sm:text-7xl text-cream leading-none mt-1"
                                style={{ letterSpacing: "-0.02em" }}
                            >
                                Sofía
                            </p>

                            <div className="my-8 mx-auto w-24 h-px bg-gold" />

                            <p className="text-cream/75 text-[14px] leading-relaxed font-light max-w-sm mx-auto">
                                Atención humana y especializada con cirugía segura, laparoscopia
                                avanzada de mínima invasión y el cuidado que te da confianza.
                            </p>

                            <div className="mt-10 grid grid-cols-2 gap-px bg-gold/30">
                                {[
                                    { l: "Atención humana", v: "Personalizada" },
                                    { l: "Cirugía", v: "Segura" },
                                    { l: "Laparoscopia", v: "Mínima invasión" },
                                    { l: "Cuidado", v: "Confianza" },
                                ].map((item) => (
                                    <div
                                        key={item.l}
                                        className="bg-navy p-4 text-center"
                                    >
                                        <p className="text-[10px] tracking-[0.24em] uppercase text-gold">
                                            {item.l}
                                        </p>
                                        <p className="mt-1 font-display text-cream text-base leading-tight">
                                            {item.v}
                                        </p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Aseguradoras;
